<script setup>
import { defineProps, defineEmits, ref, computed, watch} from "vue";
import BarraNavegacao from "./BarraNavegacao.vue";
import DadoConteudo from "./DadoConteudo.vue";
import UtilNumber from "@/utils/UtilNumber";
import UtilObject from "@/utils/UtilObject";
import UtilDateTime from "@utils/UtilDateTime";
import UtilID from "@/utils/UtilID";
import ERP from "@/api/v2/ERP.mjs";
import View from "@/api/v2/View.mjs";
import UtilArray from "@/utils/UtilArray.mjs";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "usuarioStore",
    "colaboradorStore",
    "dadoOriginal",
    "controlesDesativados",
    "revisandoDado",
]);

const emits = defineEmits([
    "update:alteraControlesDesativados",
    "update:alteraRevisandoDado",
]);

//==================================================================//
//============================= Dado ===============================//
//==================================================================//

const dado = ref({});

//==================================================================//
//======================== Preparado Dado ==========================//
//==================================================================//

const preparadoDado = ref(false);

//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

//==================================================================//
//============================== NCMs ==============================//
//==================================================================//

const ncms = ref([]);

//==================================================================//
//======================= Tipos de Transporte ======================//
//==================================================================//

const tiposDeTransporte = ref([]);

//==================================================================//
//==================== Itens Tipos de Equipamento ==================//
//==================================================================//

const itensTiposDeEquipamento = ref([]);

//==================================================================//
//==================== Itens Tipos de Servico ======================//
//==================================================================//

const itensTiposDeServico = ref([]);

//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

//==================================================================//
//=========================== Loaded NCMs ==========================//
//==================================================================//

const loadedNCMs = ref(false);

//==================================================================//
//==================== Loaded Tipos de Transporte ==================//
//==================================================================//

const loadedTiposDeTransporte = ref(false);

//==================================================================//
//================ Loaded Itens Tipos de Equipamento ===============//
//==================================================================//

const loadedItensTiposDeEquipamento = ref(false);

//==================================================================//
//================= Loaded Itens Tipos de Servico ==================//
//==================================================================//

const loadedItensTiposDeServico = ref(false);

//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

//==================================================================//
//=================== Altera Controles Desativos ===================//
//==================================================================//

const alteraControlesDesativados = (update) =>{

    emits('update:alteraControlesDesativados',update);

};

//==================================================================//
//================== Altera Revisando Dado =========================//
//==================================================================//

const alteraRevisandoDado = (update) =>{

    update.modal = false;
    emits('update:alteraRevisandoDado',update);

};

//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

//==================================================================//
//========================= Mostra Modal ===========================//
//==================================================================//

const mostraModal = computed(()=>{

    // Se o Modal não foi ativado.
    if(props.revisandoDado == false){
        return false;
    }

    // Se não Terminou de Carregar NCM
    if(loadedNCMs.value == false){
        return false;
    }

    // Se não Terminou de Carregar Tipos de Transporte
    if(loadedTiposDeTransporte.value == false){
        return false;
    }

    // Se não Terminou de Carregar Itens Tipos de Equipamento
    if(loadedItensTiposDeEquipamento.value == false){
        return false;
    }

    // Se não Terminou de Carregar Itens Tipos de Servico
    if(loadedItensTiposDeServico.value == false){
        return false;
    }

    // Se não Terminou de Preparar o Dado
    if(preparadoDado.value == false){
        return false;
    }

    return true;

});


//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//


//==================================================================//
//========================= Armazena Dado ==========================//
//==================================================================//

const armazenaDado = (update = {}) => {

    dado.value = update;

};

//==================================================================//
//==================== Altera Dado de Compra =======================//
//==================================================================//

const alteraDado = (update = {}) => {

    update.salvo = false;
    dado.value = UtilObject.merge(dado.value, update);

};

//==================================================================//
//========================== Altera Job ============================//
//==================================================================//

const alteraJob = (update = {}) => {

    /*==================================================================*/
    /*====================== ALTERA DADO ===============================*/
    /*==================================================================*/

    alteraDado(update);

    /*==================================================================*/
    /*====================== ALTERA ITENS ==============================*/
    /*==================================================================*/

    // Se o tipo de venda mudar, recalcula todos os itens com as regras do novo tipo.
    if(UtilObject.hasField(update,"tipoVenda")){

        alteraItens();

    }

};

//==================================================================//
//========================= Altera Dado ============================//
//==================================================================//

const alteraPreparadoDado = (update = false) => {

    preparadoDado.value = update;

};

//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

//==================================================================//
//============================ Altera NCMs =========================//
//==================================================================//

const alteraNCMs = (update = []) =>{
  
    ncms.value = update;

};

//==================================================================//
//===================== Altera Tipos de Transporte =================//
//==================================================================//

const alteraTiposDeTransporte = (update = []) =>{
  
    tiposDeTransporte.value = update;

};

//==================================================================//
//================ Altera Itens Tipos de Equipamento ===============//
//==================================================================//

const alteraItensTiposDeEquipamento = (update = []) =>{
  
    itensTiposDeEquipamento.value = update;

};

//==================================================================//
//==================== Altera Itens Tipos de Servico ===============//
//==================================================================//

const alteraItensTiposDeServico = (update = []) =>{
  
    itensTiposDeServico.value = update;

};

//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

//==================================================================//
//======================== Altera Loaded NCMs ======================//
//==================================================================//

const alteraLoadedNCMs = (update = false) =>{
  
    loadedNCMs.value = update;

};

//==================================================================//
//================= Altera Loaded Tipos de Transporte ==============//
//==================================================================//

const alteraLoadedTiposDeTransporte = (update = false) =>{
  
    loadedTiposDeTransporte.value = update;

};

//==================================================================//
//============= Altera Loaded Itens Tipos de Equipamento ===========//
//==================================================================//

const alteraLoadedItensTiposDeEquipamento = (update = false) =>{
  
    loadedItensTiposDeEquipamento.value = update;

};

//==================================================================//
//============= Altera Loaded Itens Tipos de Servico ===============//
//==================================================================//

const alteraLoadedItensTiposDeServico = (update = false) =>{
  
    loadedItensTiposDeServico.value = update;

};

//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

//==================================================================//
//=========================== Load NCMs ============================//
//==================================================================//

const loadNCMs = async () =>{
  
    const ncms = await ERP.getManyWithView(View.JOB_NCMS);

    alteraNCMs(ncms?.data);

    alteraLoadedNCMs(true)

};

//==================================================================//
//==================== Load Tipos de Transporte ====================//
//==================================================================//

const loadTiposDeTransporte = async () =>{
  
    const tiposDeTransporteResponse = await ERP.getManyWithView(View.JOB_TIPOS_DE_TRANSPORTE);

    alteraTiposDeTransporte(tiposDeTransporteResponse?.data);

    alteraLoadedTiposDeTransporte(true)

};

//==================================================================//
//================ Load Itens Tipos de Equipamento =================//
//==================================================================//

const loadItensTiposDeEquipamento = async() =>{
  
    const itensTiposDeEquipamentoResponse = await ERP.getManyWithView(View.JOB_ITEM_TIPOS_DE_EQUIPAMENTO);

    alteraItensTiposDeEquipamento(itensTiposDeEquipamentoResponse?.data);

    alteraLoadedItensTiposDeEquipamento(true);

};

//==================================================================//
//==================== Load Itens Tipos de Servico =================//
//==================================================================//

const loadItensTiposDeServico = async() =>{
  
    const itensTiposDeServicoResponse = await ERP.getManyWithView(View.JOB_ITEM_TIPOS_DE_SERVICO);

    alteraItensTiposDeServico(itensTiposDeServicoResponse?.data);

    alteraLoadedItensTiposDeServico(true);

};

//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

//==================================================================//
//=================== Pega Item Proxima Sequencia ==================//
//==================================================================//

const pegaItemProximaSequencia = () => {

    let itemUltimo = UtilArray.getLast(dado?.value?.itens);
    let itemUltimoSequencia = UtilNumber.toNumber(itemUltimo?.sequencia);

    let itemNovaSequencia = `${itemUltimoSequencia+1}`;
    let itemNovaSequenciaFormatada = itemNovaSequencia?.padStart(3,"0");

    return itemNovaSequenciaFormatada;

};

//==================================================================//
//======================= Adiciona Item ============================//
//==================================================================//

const adicionaItem = () => {

    let itens = dado?.value?.itens;

    let novoItem = {
        id: UtilID.generateDateTimeID(),
        aberto: false,
        salvo: false,
        remover: false,
        rascunho: true,
        status: "Em desenvolvimento",
        sequencia: pegaItemProximaSequencia(),
        tipoDeEquipamento: {},
        tipoDeServico: {},
        ncm: {},
        descricao: "",
        dataPrazoEntrega: UtilDateTime.tomorrowUTC(),
        quantidade: 1,
        precoUnitario: 0,
        precoTotal: 0,
        precoTotalLiquido: 0,
        porcentagemIPI: 0,
        valorIPI: 0,
        porcentagemBaseCalculoICMS: 0,
        porcentagemICMS: 0,
        baseCalculoICMS: 0,
        valorICMS: 0,
        porcentagemBaseCalculoPIS: 0,
        baseCalculoPIS: 0,
        porcentagemPIS: 0,
        valorPIS: 0,
        porcentagemBaseCalculoCOFINS: 0,
        baseCalculoCOFINS: 0,
        porcentagemCOFINS: 0,
        valorCOFINS: 0,
        porcentagemBaseCalculoIRRF: 0,
        baseCalculoIRRF: 0,
        porcentagemIRRF: 0,
        valorIRRF: 0,
        porcentagemBaseCalculoCSLL: 0,
        baseCalculoCSLL: 0,
        porcentagemCSLL: 0,
        valorCSLL: 0,
        porcentagemBaseCalculoISS: 0,
        baseCalculoISS: 0,
        porcentagemISS: 0,
        valorISS: 0,
        porcentagemBaseCalculoINSS: 0,
        baseCalculoINSS: 0,
        porcentagemINSS: 0,
        valorINSS: 0,
        itens: [],
        itensQuantidade: 0
    };

    itens.push(novoItem);

    alteraDado({
        salvo: false,
        itens: itens,
        itensQuantidade: itens.length,
    });

};

//==================================================================//
//======================== Remove Item =============================//
//==================================================================//

const removeItem = (update) =>{

    let itens = dado?.value?.itens?.map((item)=>{

        // Ignora os Itens que não são o Item Selecionado
        if(item.id != update.id){
            return item;
        }

        // Atualiza o Item Selecionado.
        item = UtilObject.merge(item,update);

        // Exclua todos os SubItens que tenham Rascunho.
        item.itens = item?.itens?.filter(subItem => subItem.rascunho == false);

        // Recalcula quantidade de SubItens.
        item.itensQuantidade = item.itens.length;

        // Marque todos os SubItens para exclusão.
        item.itens = item?.itens?.map((subItem)=>{

            subItem.remover = update.remover;

            return subItem;

        });

        console.log(update);

        // Abra ou feche o Item com base no Array de SubItens.
        item.aberto = UtilArray.isNotEmpty(item?.itens);

        return item;

    });

    alteraDado({
        itens: itens,
        itensQuantidade: itens.length,
    });

};

//==================================================================//
//======================= Descarta Item ============================//
//==================================================================//

const descartaItem = (update) =>{

    let itens = dado?.value?.itens?.filter(item => item.id !== update.id);

    alteraDado({
        itens: itens,
        itensQuantidade: itens.length,
    });

};

//==================================================================//
//=================== Calculo Item Produto Consumo =================//
//==================================================================//

const alteraItemCalculoProdutoConsumo = (item) =>{

    // Calcula o preço total do item (quantidade x preço unitário).
    item.precoTotal = item.quantidade * item.precoUnitario;

    // Calcula o valor do IPI sobre o preço total.
    item.valorIPI = UtilNumber.getValueFromPercentage({
        porcentagem: item.porcentagemIPI,
        valor: item.precoTotal,
    });

    // Calcula a base bruta de ICMS para Consumo: valor do produto + IPI.
    let baseCalculoICMSBruta = item.precoTotal + item.valorIPI;

    // Aplica a porcentagem da base de calculo de ICMS sobre a base bruta.
    item.baseCalculoICMS = UtilNumber.getValueFromPercentage({
        porcentagem: item.porcentagemBaseCalculoICMS,
        valor: baseCalculoICMSBruta,
    });

    // Calcula o valor de ICMS sobre a base de ICMS.
    item.valorICMS = UtilNumber.getValueFromPercentage({
        porcentagem: item.porcentagemICMS,
        valor: item.baseCalculoICMS,
    });

    // Calcula o valor do Preco Total Liquido
    item.precoTotalLiquido = item.precoTotal - item.valorICMS;

    // Calcula com a Porcentagem de Base de Calculo de PIS de:
    item.porcentagemBaseCalculoPIS = 100;

    // Aplica a porcentagem da base de calculo de COFINS sobre a base bruta.
    item.baseCalculoPIS = UtilNumber.getValueFromPercentage({
        porcentagem: item.porcentagemBaseCalculoPIS,
        valor: item.precoTotalLiquido,
    });

    // Calcula com o Valor Fixo de PIS
    item.porcentagemPIS = 1.65;

    // Calcula o valor de PIS sobre a base de PIS/COFINS.
    item.valorPIS = UtilNumber.getValueFromPercentage({
        porcentagem: item.porcentagemPIS,
        valor: item.baseCalculoPIS,
    });

    // Calcula com a Porcentagem de Base de Calculo de COFINS de:
    item.porcentagemBaseCalculoCOFINS = 100;

    // Aplica a porcentagem da base de calculo de COFINS sobre a base bruta.
    item.baseCalculoCOFINS = UtilNumber.getValueFromPercentage({
        porcentagem: item.porcentagemBaseCalculoCOFINS,
        valor: item.precoTotalLiquido,
    });

    // Calcula com o Valor Fixo de COFINS
    item.porcentagemCOFINS = 7.60;

    // Calcula o valor de COFINS sobre a base de PIS/COFINS.
    item.valorCOFINS = UtilNumber.getValueFromPercentage({
        porcentagem: item.porcentagemCOFINS,
        valor: item.baseCalculoCOFINS,
    });

    return item;

};

//==================================================================//
//================== Calculo Item Produto Revenda ==================//
//==================================================================//

const alteraItemCalculoProdutoRevenda = (item) =>{

    // Calcula o preço total do item (quantidade x preço unitário).
    item.precoTotal = item.quantidade * item.precoUnitario;

    // Calcula o valor do IPI sobre o preço total.
    item.valorIPI = UtilNumber.getValueFromPercentage({
        porcentagem: item.porcentagemIPI,
        valor: item.precoTotal,
    });

    // Calcula a base bruta de ICMS para Revenda: apenas valor do produto.
    let baseCalculoICMSBruta = item.precoTotal;

    // Aplica a porcentagem da base de calculo de ICMS sobre a base bruta.
    item.baseCalculoICMS = UtilNumber.getValueFromPercentage({
        porcentagem: item.porcentagemBaseCalculoICMS,
        valor: baseCalculoICMSBruta,
    });

    // Calcula o valor de ICMS sobre a base de ICMS.
    item.valorICMS = UtilNumber.getValueFromPercentage({
        porcentagem: item.porcentagemICMS,
        valor: item.baseCalculoICMS,
    });

    // Calcula o valor do Preco Total Liquido
    item.precoTotalLiquido = item.precoTotal - item.valorICMS;

    // Calcula com a Porcentagem de Base de Calculo de PIS de:
    item.porcentagemBaseCalculoPIS = 100;

    // Aplica a porcentagem da base de calculo de COFINS sobre a base bruta.
    item.baseCalculoPIS = UtilNumber.getValueFromPercentage({
        porcentagem: item.porcentagemBaseCalculoPIS,
        valor: item.precoTotalLiquido,
    });

    // Calcula com o Valor Fixo de PIS
    item.porcentagemPIS = 1.65;

    // Calcula o valor de PIS sobre a base de PIS/COFINS.
    item.valorPIS = UtilNumber.getValueFromPercentage({
        porcentagem: item.porcentagemPIS,
        valor: item.baseCalculoPIS,
    });

    // Calcula com a Porcentagem de Base de Calculo de COFINS de:
    item.porcentagemBaseCalculoCOFINS = 100;

    // Aplica a porcentagem da base de calculo de COFINS sobre a base bruta.
    item.baseCalculoCOFINS = UtilNumber.getValueFromPercentage({
        porcentagem: item.porcentagemBaseCalculoCOFINS,
        valor: item.precoTotalLiquido,
    });

    // Calcula com o Valor Fixo de COFINS
    item.porcentagemCOFINS = 7.60;

    // Calcula o valor de COFINS sobre a base de PIS/COFINS.
    item.valorCOFINS = UtilNumber.getValueFromPercentage({
        porcentagem: item.porcentagemCOFINS,
        valor: item.baseCalculoCOFINS,
    });

    return item;

};

//==================================================================//
//================== Calculo Item Produto Recap ====================//
//==================================================================//

const alteraItemCalculoProdutoRecap = (item) =>{

    // Calcula o preço total do item (quantidade x preço unitário).
    item.precoTotal = item.quantidade * item.precoUnitario;

    // Calcula o valor do IPI sobre o preço total.
    item.valorIPI = UtilNumber.getValueFromPercentage({
        porcentagem: item.porcentagemIPI,
        valor: item.precoTotal,
    });

    // Calcula a base bruta de ICMS para Recap: valor do produto + IPI.
    let baseCalculoICMSBruta = item.precoTotal + item.valorIPI;

    // Aplica a porcentagem da base de calculo de ICMS sobre a base bruta.
    item.baseCalculoICMS = UtilNumber.getValueFromPercentage({
        porcentagem: item.porcentagemBaseCalculoICMS,
        valor: baseCalculoICMSBruta,
    });

    // Calcula o valor de ICMS sobre a base de ICMS.
    item.valorICMS = UtilNumber.getValueFromPercentage({
        porcentagem: item.porcentagemICMS,
        valor: item.baseCalculoICMS,
    });

    // Calcula o valor do Preco Total Liquido
    item.precoTotalLiquido = item.precoTotal - item.valorICMS;

    // Limpa Valores de PIS pois é Isento
    item.porcentagemBaseCalculoPIS = 0;
    item.baseCalculoPIS = 0;
    item.porcentagemPIS = 0;
    item.valorPIS = 0;

    // Limpa Valores de COFINS pois é Isento
    item.porcentagemBaseCalculoCOFINS = 0;
    item.baseCalculoCOFINS = 0;
    item.porcentagemCOFINS = 0;
    item.valorCOFINS = 0;

    return item;

};


//==================================================================//
//====================== Calculo Item Servico ======================//
//==================================================================//

const alteraItemCalculoServico = (item) =>{

    // Calcula o preço total do item (quantidade x preço unitário).
    item.precoTotal = item.quantidade * item.precoUnitario;

    // Limpa Valores de IPI pois não utiliza
    item.porcentagemIPI = 0;
    item.valorIPI = 0;

    // Limpa Valores de ICMS pois não utiliza
    item.porcentagemBaseCalculoICMS = 0;
    item.baseCalculoICMS = 0;
    item.porcentagemICMS = 0;
    item.valorICMS = 0;

    // Calcula a base de ISS sobre o valor líquido do serviço.
    item.baseCalculoISS = UtilNumber.getValueFromPercentage({
        porcentagem: item.porcentagemBaseCalculoISS,
        valor: item.precoTotal,
    });

    // Calcula o valor de ISS sobre a base de ISS.
    item.valorISS = UtilNumber.getValueFromPercentage({
        porcentagem: item.porcentagemISS,
        valor: item.baseCalculoISS,
    });

    // Calcula a base de PIS sobre o valor líquido do serviço.
    item.baseCalculoPIS = UtilNumber.getValueFromPercentage({
        porcentagem: item.porcentagemBaseCalculoPIS,
        valor: item.precoTotal - item.valorISS,
    });

    // Calcula o valor de PIS sobre a base de PIS.
    item.valorPIS = UtilNumber.getValueFromPercentage({
        porcentagem: item.porcentagemPIS,
        valor: item.baseCalculoPIS,
    });

    // Calcula a base de COFINS sobre o valor líquido do serviço.
    item.baseCalculoCOFINS = UtilNumber.getValueFromPercentage({
        porcentagem: item.porcentagemBaseCalculoCOFINS,
        valor: item.precoTotal - item.valorISS,
    });

    // Calcula o valor de COFINS sobre a base de COFINS.
    item.valorCOFINS = UtilNumber.getValueFromPercentage({
        porcentagem: item.porcentagemCOFINS,
        valor: item.baseCalculoCOFINS,
    });

    // Calcula a base de IRRF sobre o valor líquido do serviço.
    item.baseCalculoIRRF = UtilNumber.getValueFromPercentage({
        porcentagem: item.porcentagemBaseCalculoIRRF,
        valor: item.precoTotal - item.valorISS,
    });

    // Calcula o valor de IRRF sobre a base de IRRF.
    item.valorIRRF = UtilNumber.getValueFromPercentage({
        porcentagem: item.porcentagemIRRF,
        valor: item.baseCalculoIRRF,
    });

    // Calcula a base de CSLL sobre o valor líquido do serviço.
    item.baseCalculoCSLL = UtilNumber.getValueFromPercentage({
        porcentagem: item.porcentagemBaseCalculoCSLL,
        valor: item.precoTotal - item.valorISS,
    });

    // Calcula o valor de CSLL sobre a base de CSLL.
    item.valorCSLL = UtilNumber.getValueFromPercentage({
        porcentagem: item.porcentagemCSLL,
        valor: item.baseCalculoCSLL,
    });

    // Calcula a base de INSS sobre o valor líquido do serviço.
    item.baseCalculoINSS = UtilNumber.getValueFromPercentage({
        porcentagem: item.porcentagemBaseCalculoINSS,
        valor: item.precoTotal - item.valorISS,
    });

    // Calcula o valor de INSS sobre a base de INSS.
    item.valorINSS = UtilNumber.getValueFromPercentage({
        porcentagem: item.porcentagemINSS,
        valor: item.baseCalculoINSS,
    });

    // Soma todos os Impostos de Serviço
    let somaImpostosServico = item.valorPIS + item.valorCOFINS + item.valorIRRF + item.valorCSLL + item.valorISS + item.valorINSS;

    // Calcula o valor do Preco Total Liquido
    item.precoTotalLiquido = item.precoTotal - somaImpostosServico;

    return item;

};

//==================================================================//
//================= Altera Item Calculo Produto ====================//
//==================================================================//

const alteraItemCalculoProduto = (item = {}) =>{

    if(dado?.value?.tipoVenda === 'Consumo'){

        return alteraItemCalculoProdutoConsumo(item);

    }

    if(dado?.value?.tipoVenda === 'Revenda'){

        return alteraItemCalculoProdutoRevenda(item);

    }

    if(dado?.value?.tipoVenda === 'Recap'){

        return alteraItemCalculoProdutoRecap(item);

    }

    return item;

};

//==================================================================//
//========================== Altera Item Calculo ===================//
//==================================================================//

const alteraItemCalculo = (item = {}) =>{

    // Tipo de Equipamento é Produto.
    if(item.tipoDeEquipamento.descricao != "SERVICOS"){

        alteraItemCalculoProduto(item);

    }

    // Tipo de Equipamento é Serviço;
    if(item.tipoDeEquipamento.descricao == "SERVICOS"){

        alteraItemCalculoServico(item);

    }

    return item;

};

//==================================================================//
//========================= Altera Item ============================//
//==================================================================//

const alteraItem = (update) => {

    let itens = dado?.value?.itens?.map((item)=>{

        // Ignora os Itens que não são o Item Selecionado
        if(item.id != update.id){
            return item;
        }

        // Altere o Item.
        item = UtilObject.merge(item, update);

        // Calcula o Item.
        item = alteraItemCalculo(item);

        return item;

    });

    alteraDado({
        itens: itens
    });

};

//==================================================================//
//========================= Altera Itens ===========================//
//==================================================================//

const alteraItens = (update = {}) => {

    let itens = dado?.value?.itens?.map((item = {})=>{

        // Altere o Item.
        if(UtilObject.isNotEmpty(update)){
            item = UtilObject.merge(item, update);
        }

        // Calcula o Item.
        item = alteraItemCalculo(item);

        return item;

    });

    alteraDado({
        itens: itens
    });

};

//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

//==================================================================//
//================= Pega Subitem Proxima Sequencia =================//
//==================================================================//

const pegaSubitemProximaSequencia = (item)=>{

    let subItemUltimo = UtilArray.getLast(item?.itens);
    let subItemUltimoSequencia = UtilNumber.toNumber(subItemUltimo?.sequencia);

    let subItemNovaSequencia = `${subItemUltimoSequencia+1}`;
    let subItemNovaSequenciaFormatada = subItemNovaSequencia?.padStart(3,"0");

    return subItemNovaSequenciaFormatada;

};

//==================================================================//
//====================== Adiciona Subitem ==========================//
//==================================================================//

const adicionaSubitem = (update) =>{

    let itens = dado?.value?.itens?.map((item)=>{

        if(item?.id != update?.id){
            return item;
        }

        item.itens.push({
            id: UtilID.generateDateTimeID(),
            salvo: false,
            remover: false,
            rascunho: true,
            sequencia: pegaSubitemProximaSequencia(item),
            status: "Em desenvolvimento",
            descricao: "",
            quantidade: 1,
            valorUnitario: 0,
            valorTotal: 0,
        });

        item.aberto = true;
        item.itensQuantidade = item.itens.length;

        return item;

    });

    alteraDado({
        itens: itens,
    });

};

//==================================================================//
//====================== Remove Subitem ============================//
//==================================================================//

const removeSubitem = (update) =>{

    let itens = dado?.value?.itens?.map((item)=>{

        // Ignora os Itens que não são o Item Selecionado
        if(item.id != update?.item?.id){
            return item;
        }

        // Ignora os SubItens que não são o Item Selecionado
        item.itens = item?.itens?.map((subItem)=>{

            if(subItem.id != update.subItem.id){
                return subItem;
            }

            // Altera os SubItens.
            subItem = UtilObject.merge(subItem,update.subItem);

            return subItem;

        });

        // Recalcula quantidade de SubItens.
        item.itensQuantidade = item.itens.length;

        // Abra ou feche o Item com base no Array de SubItens.
        item.aberto = UtilArray.isNotEmpty(item?.itens);

        return item;

    });

    alteraDado({
        itens: itens,
    });

};

//==================================================================//
//===================== Descarta Subitem ===========================//
//==================================================================//

const descartaSubitem = (update) =>{

    let itens = dado?.value?.itens?.map(item => {

        // Ignora os Itens que não são o Item Selecionado
        if(item.id != update?.item?.id){
            return item;
        }

        // Descarta SubItem.
        item.itens = item?.itens?.filter(subItem => subItem.id !== update?.subItem?.id);

        // Recalcula quantidade de SubItens.
        item.itensQuantidade = item?.itens?.length;

        // Abra ou feche o Item com base no Array de SubItens.
        item.aberto = UtilArray.isNotEmpty(item?.itens);

        return item;

    });

    alteraDado({
        itens: itens,
    });

};

//==================================================================//
//======================= Altera Subitem ===========================//
//==================================================================//

const alteraSubitem = (update) => {

    let itens = dado?.value?.itens?.map((item)=>{

        // Ignora os Itens que não são o Item Selecionado.
        if(item.id != update.item.id){
            return item;
        }

        item.itens = item?.itens?.map((subItem)=>{

            // Ignora os SubItens que não são o SubItem Selecionado.
            if(subItem.id != update.subItem.id){
                return subItem;
            }

            // Altera o SubItem.
            subItem = UtilObject.merge(subItem,update.subItem);

            // Calcula o Valor Total.
            subItem.valorTotal = subItem.quantidade * subItem.valorUnitario;

            return subItem;

        });
    
        return item;

    });

    alteraDado({
        salvo: false,
        itens: itens,
    });

};

//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//
//<*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*><*>//

//===================================================================//
//========================== Prepara Dado ===========================//
//=================================================-=================//

const preparaDado = (dado = {}) => {

    let itens = dado?.itens?.map((item)=>{

        let subItens = item?.itens?.map((subItem)=>{

            return{
                id: subItem?.id || "",
                salvo: true,
                remover: false,
                rascunho: false,
                codigo: subItem?.codigo || "",
                status: subItem?.status || "",
                sequencia: subItem?.sequencia || "",
                descricao: subItem?.descricao || "",
                quantidade: subItem?.quantidade || 1,
                valorUnitario: subItem?.valorUnitario || 0,
                valorTotal: subItem?.valorTotal || 0,
            };

        });

        return{
            id: item?.id || "",
            aberto: false,
            salvo: true,
            remover: false,
            rascunho: false,
            codigo: item?.codigo || "",
            status: item?.status || "",
            sequencia: item?.sequencia || "",
            ncm: item?.ncm || {},
            tipoDeEquipamento: item?.tipoDeEquipamento || {},
            tipoDeServico: item?.tipoDeServico || {},
            descricao: item?.descricao || "",
            dataPrazoEntrega: item?.dataPrazoEntrega || "",
            quantidade: item?.quantidade || 1,
            precoUnitario: item?.precoUnitario || 0,
            precoTotal: item?.precoTotal || 0,
            precoTotalLiquido: item?.precoTotalLiquido || 0,
            porcentagemIPI: item?.porcentagemIPI || 0,
            valorIPI: item?.valorIPI || 0,
            porcentagemBaseCalculoICMS: item?.porcentagemBaseCalculoICMS || 0,
            porcentagemICMS: item?.porcentagemICMS || 0,
            baseCalculoICMS: item?.baseCalculoICMS || 0,
            valorICMS: item?.valorICMS || 0,
            porcentagemBaseCalculoPIS: item?.porcentagemBaseCalculoPIS || 0,
            baseCalculoPIS: item?.baseCalculoPIS || 0,
            porcentagemPIS: item?.porcentagemPIS || 0,
            valorPIS: item?.valorPIS || 0,
            porcentagemBaseCalculoCOFINS: item?.porcentagemBaseCalculoCOFINS || 0,
            baseCalculoCOFINS: item?.baseCalculoCOFINS || 0,
            porcentagemCOFINS: item?.porcentagemCOFINS || 0,
            valorCOFINS: item?.valorCOFINS || 0,
            porcentagemBaseCalculoIRRF: item?.porcentagemBaseCalculoIRRF || 0,
            baseCalculoIRRF: item?.baseCalculoIRRF || 0,
            porcentagemIRRF: item?.porcentagemIRRF || 0,
            valorIRRF: item?.valorIRRF || 0,
            porcentagemBaseCalculoCSLL: item?.porcentagemBaseCalculoCSLL || 0,
            baseCalculoCSLL: item?.baseCalculoCSLL || 0,
            porcentagemCSLL: item?.porcentagemCSLL || 0,
            valorCSLL: item?.valorCSLL || 0,
            porcentagemBaseCalculoISS: item?.porcentagemBaseCalculoISS || 0,
            baseCalculoISS: item?.baseCalculoISS || 0,
            porcentagemISS: item?.porcentagemISS || 0,
            valorISS: item?.valorISS || 0,
            porcentagemBaseCalculoINSS: item?.porcentagemBaseCalculoINSS || 0,
            baseCalculoINSS: item?.baseCalculoINSS || 0,
            porcentagemINSS: item?.porcentagemINSS || 0,
            valorINSS: item?.valorINSS || 0,
            itens: subItens || [],
            itensQuantidade: item?.itensQuantidade || 0,
        };

    });

    let aditivos = dado?.aditivos?.map((aditivo)=>{

        return{
            id: aditivo?.id || "",
            codigo: aditivo?.codigo || "",
            descricao: aditivo?.descricao || "",
            valorAdicional: aditivo?.valorAdicional || 0,
        };

    });

    dado = {
        id: dado?.id || "",
        salvo: true,
        status: dado?.status || "",
        codigo: dado?.codigo || "",
        jobTipo: dado?.jobTipo || "",
        tipoVenda: dado?.tipoVenda || "",

        valorDeCusto: dado?.valorDeCusto || 0,
        valorDeVenda: dado?.valorDeVenda || 0,
        valorDeVendaComImpostos: dado?.valorDeVendaComImpostos || 0,

        descricao: dado?.descricao || "",
        condicaoDePagamento: dado?.condicaoDePagamento || "",
        observacao: dado?.observacao || "",

        dataAbertura: dado?.dataAbertura || "",
        dataAberturaFormatada: dado?.dataAberturaFormatada || "",

        dataEntregaContratual: dado?.dataEntregaContratual || "",
        dataEntregaContratualFormatada: dado?.dataEntregaContratualFormatada || "",
        dataEncerramento: dado?.dataEncerramento || "",
        dataEncerramentoFormatada: dado?.dataEncerramentoFormatada || "",

        dataEnvioAprovacaoContratual: dado?.dataEnvioAprovacaoContratual || "",
        dataEnvioAprovacaoContratualFormatada: dado?.dataEnvioAprovacaoContratualFormatada || "",
        dataEnvioAprovacaoEfetiva: dado?.dataEnvioAprovacaoEfetiva || "",
        dataEnvioAprovacaoEfetivaFormatada: dado?.dataEnvioAprovacaoEfetivaFormatada || "",
        naoTemEnvioAprovacao: dado?.naoTemEnvioAprovacao || false,

        dataAprovacaoPrevista: dado?.dataAprovacaoPrevista || "",
        dataAprovacaoPrevistaFormatada: dado?.dataAprovacaoPrevistaFormatada || "",
        dataAprovacaoEfetiva: dado?.dataAprovacaoEfetiva || "",
        dataAprovacaoEfetivaFormatada: dado?.dataAprovacaoEfetivaFormatada || "",
        naoTemAprovacao: dado?.naoTemAprovacao || false,

        dataInspecaoPrevista: dado?.dataInspecaoPrevista || "",
        dataInspecaoPrevistaFormatada: dado?.dataInspecaoPrevistaFormatada || "",
        dataInspecaoEfetiva: dado?.dataInspecaoEfetiva || "",
        dataInspecaoEfetivaFormatada: dado?.dataInspecaoEfetivaFormatada || "",
        naoTemInspecao: dado?.naoTemInspecao || false,

        dataEntregaFiscalPrevista: dado?.dataEntregaFiscalPrevista || "",
        dataEntregaFiscalPrevistaFormatada: dado?.dataEntregaFiscalPrevistaFormatada || "",
        dataEntregaFiscalEfetiva: dado?.dataEntregaFiscalEfetiva || "",
        dataEntregaFiscalEfetivaFormatada: dado?.dataEntregaFiscalEfetivaFormatada || "",
        naoTemEntregaFiscal: dado?.naoTemEntregaFiscal || false,

        dataMontagemContratual: dado?.dataMontagemContratual || "",
        dataMontagemContratualFormatada: dado?.dataMontagemContratualFormatada || "",
        dataMontagemEfetiva: dado?.dataMontagemEfetiva || "",
        dataMontagemEfetivaFormatada: dado?.dataMontagemEfetivaFormatada || "",
        naoTemMontagem: dado?.naoTemMontagem || false,

        dataStartupPrevista: dado?.dataStartupPrevista || "",
        dataStartupPrevistaFormatada: dado?.dataStartupPrevistaFormatada || "",
        dataStartupEfetiva: dado?.dataStartupEfetiva || "",
        dataStartupEfetivaFormatada: dado?.dataStartupEfetivaFormatada || "",
        naoTemStartup: dado?.naoTemStartup || false,

        dataFinalContratual: dado?.dataFinalContratual || "",
        dataFinalContratualFormatada: dado?.dataFinalContratualFormatada || "",
        dataFinalEfetiva: dado?.dataFinalEfetiva || "",
        dataFinalEfetivaFormatada: dado?.dataFinalEfetivaFormatada || "",

        solicitacaoDeOrcamentoID: dado?.solicitacaoDeOrcamento?.id || "",
        solicitacaoDeOrcamentoCodigo: dado?.solicitacaoDeOrcamento?.codigo || "",
        solicitacaoDeOrcamentoValor: dado?.solicitacaoDeOrcamento?.valor || "",

        solicitacaoDeOrcamentoTipoDeEquipamentoID: dado?.solicitacaoDeOrcamento?.tipoDeEquipamento?.id || "",
        solicitacaoDeOrcamentoTipoDeEquipamentoSigla: dado?.solicitacaoDeOrcamento?.tipoDeEquipamento?.sigla || "",
        solicitacaoDeOrcamentoTipoDeEquipamentoDescricao: dado?.solicitacaoDeOrcamento?.tipoDeEquipamento?.descricao || "",

        solicitacaoDeOrcamentoContatoComercialID: dado?.solicitacaoDeOrcamento?.contatoComercial?.id || "",
        solicitacaoDeOrcamentoContatoComercialTipo: dado?.solicitacaoDeOrcamento?.contatoComercial?.tipo || "",
        solicitacaoDeOrcamentoContatoComercialNome: dado?.solicitacaoDeOrcamento?.contatoComercial?.nome || "",

        solicitacaoDeOrcamentoContatoTecnicoID: dado?.solicitacaoDeOrcamento?.contatoTecnico?.id || "",
        solicitacaoDeOrcamentoContatoTecnicoTipo: dado?.solicitacaoDeOrcamento?.contatoTecnico?.tipo || "",
        solicitacaoDeOrcamentoContatoTecnicoNome: dado?.solicitacaoDeOrcamento?.contatoTecnico?.nome || "",

        clienteID: dado?.cliente?.id || "",
        clienteCodigo: dado?.cliente?.codigo || "",
        clienteNome: dado?.cliente?.nomeFantasia || "",
        clientePedidoDeCompra: dado?.clientePedidoDeCompra || "",
        clienteEmailXML: dado?.clienteEmailXML || "",

        comercialID: dado?.comercial?.id || "",
        comercialCodigo: dado?.comercial?.codigo || "",
        comercialNome: dado?.comercial?.nome || "",

        gestorID: dado?.gestorDeContratos?.id || "",
        gestorCodigo: dado?.gestorDeContratos?.codigo || "",
        gestorNome: dado?.gestorDeContratos?.nome || "",

        coordenadorID: dado?.coordenadorDeContratos?.id || "",
        coordenadorCodigo: dado?.coordenadorDeContratos?.codigo || "",
        coordenadorNome: dado?.coordenadorDeContratos?.nome || "",

        transporte: dado?.transporte || {},

        itens: itens || [],
        itensQuantidade: dado?.itensQuantidade || 0,

        aditivos: aditivos || [],
        aditivosQuantidade : dado?.aditivosQuantidade || 0,
    };

    armazenaDado(dado);
    alteraPreparadoDado(true);

};

//==================================================================//
//======================== Prepara Modal ===========================//
//==================================================================//

const preparaModal = async () => {

    await loadNCMs();
    await loadTiposDeTransporte();
    await loadItensTiposDeEquipamento();
    await loadItensTiposDeServico();

    preparaDado(UtilObject.clone(props?.dadoOriginal));

};

//====================================================================//
//==== Prepara Modal se Dados Originais Carregados ou Recarregados ===//
//===================== Watch => revisandoDado =======================//
//====================================================================//

watch(()=> props?.revisandoDado, async() => {

    if(props?.revisandoDado == false){
        alteraPreparadoDado(false);
    }

    if(props?.revisandoDado == true){
        await preparaModal();
    }

},{ immediate: true });


</script>

<template>

    <main>

        <v-dialog
            content-class="c-dialog"
            v-model="mostraModal"
            fullscreen
            transition="dialog-bottom-transition"
            persistent
        >

            <v-card class="c-modal">

                <BarraNavegacao
                    :usuarioStore="props.usuarioStore"
                    :colaboradorStore="props.colaboradorStore"
                    :dado="dado"
                    :revisandoDado="props.revisandoDado"
                    :controlesDesativados="props.controlesDesativados"
                    @update:alteraControlesDesativados="alteraControlesDesativados"
                    @update:alteraRevisandoDado="alteraRevisandoDado"
                ></BarraNavegacao>

                <DadoConteudo
                    :dado="dado"
                    :revisandoDado="props.revisandoDado"
                    :ncms="ncms"
                    :tiposDeTransporte="tiposDeTransporte"
                    :itensTiposDeEquipamento="itensTiposDeEquipamento"
                    :itensTiposDeServico="itensTiposDeServico"
                    :controlesDesativados="props.controlesDesativados"
                    @update:alteraJob="alteraJob"
                    @update:adicionaItem="adicionaItem"
                    @update:removeItem="removeItem"
                    @update:descartaItem="descartaItem"
                    @update:alteraItem="alteraItem"
                    @update:adicionaSubitem="adicionaSubitem"
                    @update:removeSubitem="removeSubitem"
                    @update:descartaSubitem="descartaSubitem"
                    @update:alteraSubitem="alteraSubitem"
                ></DadoConteudo>
            
            </v-card>

        </v-dialog>

    </main>

</template>

<style scoped>

.v-dialog__content >>> .v-dialog{
    background-color: white;
}

</style>

